import React from "react";
import {
    Divider,
    Dropdown,
    Flex,
    InputLabel,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";
import { DEVICE } from "../../../../../constants/responsive";

const DialogUpdateAgencyDepartmentContent = ({
    services,
    agencies,
    isLoadingAgencies,
    isLoadingServices,
    default_agency_id,
    default_service_id,
    onChangeDropdownSelection,
}) => {
    // format list of agencies and services.
    const formated_services = services?.map((service) => {
        return {
            id: service?.id,
            key: service?.id,
            header: service?.name,
        };
    });
    const formated_agencies = agencies?.map((agence) => {
        return {
            id: agence?.id,
            key: agence?.id,
            header: agence?.name,
        };
    });

    const _onChangeAgency = (_, i) => {
        const value = i?.value?.id;
        return onChangeDropdownSelection((state) => {
            return {
                ...state,
                agency_id: value,
            };
        });
    };
    const _onChangeDepartment = (_, i) => {
        const value = i?.value?.id;
        return onChangeDropdownSelection((state) => {
            return {
                ...state,
                department_id: value,
            };
        });
    };

    return (
        <Flex fill column>
            <Wrapper column gap="gap.large">
                <Flex column>
                    <InputLabel content={"Agence"} />
                    <Dropdown
                        items={formated_agencies}
                        placeholder=""
                        checkable
                        loading={isLoadingAgencies}
                        onChange={_onChangeAgency}
                        fluid
                        defaultValue={formated_agencies?.filter(
                            (agency) => agency?.id === default_agency_id
                        )}
                        getA11ySelectionMessage={{
                            onAdd: (item) => `${item} has been selected.`,
                        }}
                    />
                </Flex>
                <div style={{ position: "relative" }}>
                    <InputLabel content={"Département"} />
                    <DropdownStyles
                        items={formated_services}
                        loading={isLoadingServices}
                        placeholder=""
                        defaultValue={formated_services?.filter(
                            (service) => service?.id === default_service_id
                        )}
                        onChange={_onChangeDepartment}
                        checkable
                        getA11ySelectionMessage={{
                            onAdd: (item) => `${item} has been selected.`,
                        }}
                        position="below"
                        positionFixed={true}
                        fluid
                    />
                </div>
                <Divider styles={{ paddingTop: "24px" }} />
            </Wrapper>
        </Flex>
    );
};

export default DialogUpdateAgencyDepartmentContent;

const Wrapper = styled(Flex)`
    /* border-bottom: 1px solid #d1d1d1; */
    padding-block: 24px;
`;

const DropdownStyles = styled(Dropdown)`
    @media ${DEVICE.mobileS} {
        ul {
            width: 276px;
            max-width: 276px;
        }
        .ui-dropdown__container {
            width: 276px;
        }
    }
    @media ${DEVICE.mobileM} {
        ul {
            width: 296px;
            max-width: 296px;
        }
        .ui-dropdown__container {
            width: 296px;
        }
    }
    @media ${DEVICE.mobileL} {
        ul {
            width: 367px;
            max-width: 367px;
        }
        .ui-dropdown__container {
            width: 367px;
        }
    }
    @media ${DEVICE.tablet} {
        ul {
            width: 327px;
            max-width: 327px;
        }
        .ui-dropdown__container {
            width: 327px;
        }
    }
`;
